<template>
  <div class="box-big">
    <div class="box" :style="boxStyle">
      <div class="date-left">
        <!-- 星期 -->
        <ul class="weekdays">
          <li>周一</li>
          <li>周二</li>
          <li>周三</li>
          <li>周四</li>
          <li>周五</li>
          <li>周六</li>
          <li>周日</li>
        </ul>
        <!-- 日期 -->
        <ul class="days">
          <li v-for="(day, index) in days" :key="index">
            <div :class="{ cursor: day }" @click="pick(day)">
              <span
                v-if="day"
                :class="{ today: isToday(day), active: isChecked(day) }"
                >{{ day.getDate() }}</span
              >
              <span v-else></span>
            </div>
          </li>
        </ul>
      </div>
      <div class="data-right">
        <div class="data-right-box">
          <i class="el-icon-arrow-left cursor" @click="preOrNext(-1)"></i>
          <div class="data-right-div">
            <p>
              {{
                `${currentYear} ${
                  currentMonth >= 10 ? currentMonth : '0' + currentMonth
                }`
              }}
            </p>
            <p>{{ `${currentDay} ${statusText(currentWeek)}` }}</p>
          </div>
          <i class="el-icon-arrow-right cursor" @click="preOrNext(1)"></i>
        </div>
      </div>
    </div>
    <div class="box-bottom">
      <div class="cursor" @click="changeDayType">
        <i class="el-icon-arrow-down" :class="{ up: dayType === 'month' }"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Date',
  props: {
    type: {
      type: String,
      default: 'week',
    },
    value: {
      type: Date,
      default: () => {
        return new Date()
      },
    },
  },
  data() {
    return {
      dayType: this.type,
      checked: this.value,
      days: [],
      statusDayText: {
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        7: '周天',
      },
    }
  },
  computed: {
    // 盒子高度
    boxStyle() {
      const style = {}
      style.height = this.dayType === 'week' ? '109px' : '309px'
      return style
    },
    // 获取状态文字
    statusText() {
      return (status) => {
        return this.statusDayText[status]
      }
    },
    isToday() {
      return (day) => {
        const date = new Date()
        return (
          day.getFullYear() === date.getFullYear() &&
          day.getMonth() === date.getMonth() &&
          day.getDate() === date.getDate()
        )
      }
    },
    isChecked() {
      return (day) => {
        return (
          day.getFullYear() === this.checked.getFullYear() &&
          day.getMonth() === this.checked.getMonth() &&
          day.getDate() === this.checked.getDate()
        )
      }
    },
    currentYear() {
      return this.checked.getFullYear()
    },
    currentMonth() {
      return this.checked.getMonth() + 1
    },
    currentDay() {
      return this.checked.getDate()
    },
    currentWeek() {
      const week = this.checked.getDay()
      return week === 0 ? 7 : week
    },
  },
  watch: {
    type(e) {
      this.dayType = e
    },
    dayType() {
      this.initData()
    },
  },
  mounted() {},
  created() {
    this.initData()
  },

  methods: {
    formatDate(year, month, day) {
      const y = year
      let m = month
      if (m < 10) m = `0${m}`
      let d = day
      if (d < 10) d = `0${d}`
      return `${y}-${m}-${d}`
    },

    initData() {
      const str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      ) // 今日日期 年-月-日
      const days = []
      // 今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
      /* eslint-disabled */
      if (this.dayType === 'week') {
        for (let i = this.currentWeek - 1; i >= 0; i -= 1) {
          const d = new Date(str)
          d.setDate(d.getDate() - i)
          days.push(d)
        }
        for (let i = 1; i <= 7 - this.currentWeek; i += 1) {
          const d = new Date(str)
          d.setDate(d.getDate() + i)
          days.push(d)
        }
      } else if (this.dayType === 'month') {
        let forDay = new Date(
          this.formatDate(this.currentYear, this.currentMonth, 1)
        )
        const firstWeek = forDay.getDay()
        const emptyNum = firstWeek === 0 ? 6 : firstWeek - 1
        for (let i = 0; i < emptyNum; i++) {
          days.push(null)
        }
        while (
          forDay.getFullYear() <= this.currentYear &&
          forDay.getMonth() <= this.currentMonth - 1
        ) {
          days.push(forDay)
          forDay = new Date(forDay.getTime() + 86400000)
        }
      }
      this.days = days
    },

    // 前后切换 e -1 或 1
    preOrNext(e) {
      const nowDay = this.checked
      let date
      switch (this.dayType) {
        case 'week': {
          date = new Date(nowDay.getTime() + 86400000 * 7 * e)
          break
        }
        case 'month': {
          const targetMonth = new Date(nowDay.getTime()) // 不直接修改原对象
          if (e > 0) {
            targetMonth.setMonth(nowDay.getMonth() + 2)
          }
          targetMonth.setDate(0) // 上月最后一天，当前月为一月时这种写法会退到上一年十二月
          if (nowDay.getDate() <= targetMonth.getDate()) {
            targetMonth.setDate(nowDay.getDate())
          }
          date = targetMonth
          break
        }
      }
      if (date) {
        this.pick(date)
        this.initData()
      }
    },

    // 下个星期
    tipNext() {
      const d = this.days[6] // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() + 7)
      this.initData(d)
    },

    // 当前选择日期
    pick(date) {
      if (date && !this.isChecked(date)) {
        this.checked = date
        this.$emit('input', date)
      }
    },
    // 切换周/月历
    changeDayType() {
      this.dayType = this.dayType === 'week' ? 'month' : 'week'
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  border-bottom: 1px solid #f2f2f2;
  transition: height 0.3s;
  overflow: hidden;
}
.box-bottom {
  text-align: center;
  padding: 0;
  > div {
    display: inline-block;
    width: 70px;
    height: 22px;
    line-height: 22px;
    border-radius: 0 0 18px 18px;
    box-shadow: 0px 5px 8px 0px rgba(0, 0, 0, 0.05);
    > i {
      transition: all 0.3s;
      &.up {
        transform: rotate(180deg);
      }
    }
  }
}
.data-right {
  flex: 1;

  .data-right-box {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    color: #000000;
  }
  i {
    font-size: 20px;
    color: #000;
  }
  .data-right-div {
    text-align: center;

    p:last-child {
      text-align: center;
      font-size: 16px;
      color: #666666;
      margin-top: 8px;
    }
  }
}
.date-left {
  width: 67%;
  color: #333;
  margin-right: 70px;
  li::marker {
    content: none;
  }
  .month {
    text-align: center;
  }

  .weekdays {
    display: flex;
    padding: 0;
    font-size: 15px;
    color: #666666;
    li {
      flex: 1;
      text-align: center;
      width: 14.28%;
      line-height: 24px;
    }
  }

  .days {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    li {
      text-align: center;
      width: 14.28%;
      line-height: 24px;
      box-sizing: border-box;
      padding: 8px 15px;

      > div {
        > span {
          display: inline-block;
          width: 24px;
          text-align: center;
          transition: all 0.3s;
          &.today {
            color: rgba(65, 156, 255);
          }
          &.active {
            color: #fff !important;
            border-radius: 5px;
            background-color: rgba(65, 156, 255);
          }
        }
      }

      .other-month {
        color: #e4393c;
      }
    }
  }
}
</style>
